import layout from '@/views/layout/layout.vue'
const marketingActionList = r => require.ensure([], () => r(require('@/views/marketing/marketingAction/list.vue')), 'group-system-marketingAction')

const marketingActionConfig = [
  {
    path: '/marketing/marketingAction',
    name: 'marketing-marketingAction',
    component: layout,
    redirect: '/marketing/marketingAction/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: marketingActionList,
        name: 'system-marketingAction-list',
        meta: {
          displayName: '签呈管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default marketingActionConfig



// WEBPACK FOOTER //
// ./src/router/marketing/marketingAction.js